import { QuestionOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Tag, Flex } from "antd";

import React from "react";
import { SettingCard } from "~/components/dataCards/SettingCard.jsx";
import { config } from "~/config.js";
import { $t } from "~/i18n.js";
import { pricePlans, planAlias } from "~/featureMatrix.jsx";

export const PlanTerms = ({ clubData }) => {
  // comment to add plan key in translation
  // $t('test')
  // $t('small')
  // $t('large')
  // $t('free')
  // $t('cancelled')

  const mainPlan = planAlias[clubData.plan] || clubData.plan;

  // Determine the correct pricing URL based on language configuration
  const pricingUrl = `https://www.gliding.app${
    config.isZweef ? "/nl" : ""
  }/pricing.html`;
  const email = `contact@${config.isZweef ? "zweef" : "gliding"}.app`;

  return (
    <SettingCard title={$t("Plan en voorwaarden")}>
      <Row gutter={12} style={{ marginBottom: 18 }}>
        <Col span={8} style={{ textAlign: "right" }}>
          {$t("Prijsplan")}:{" "}
        </Col>
        <Col span={16}>
          <Flex wrap="wrap" style={{ gap: 12 }}>
            {pricePlans.map((plan) => (
              <Tag
                key={plan.key}
                color={mainPlan === plan.key ? "green" : "default"}
                style={{
                  padding: 6,
                  borderRadius: 8,
                  background: mainPlan === plan.key ? "#e6ffed" : "#fafafa",
                  maxWidth: 140,
                  minHeight: 60,
                  display: "flex",
                  flexDirection: "column",
                  boxShadow:
                    mainPlan === plan.key ? "0 0 0 1px #e6ffed" : "none",
                  color: "black",
                }}
              >
                <div style={{ fontWeight: 700, marginBottom: 2 }}>
                  {$t(plan.title)}
                </div>
                <div
                  style={{
                    whiteSpace: "normal",
                    lineHeight: 1.3,
                  }}
                >
                  {$t(plan.description)}
                </div>
              </Tag>
            ))}
          </Flex>

          <p style={{ marginTop: 12 }}>
            {$t("Bekijk details van de prijsplannen via")}
            <a
              style={{ marginLeft: 6 }}
              shape="circle"
              size="small"
              target="_blank"
              href={pricingUrl}
            >
              {$t("deze link")}
            </a>
          </p>

          <div style={{ marginTop: 12 }}>
            <b>{$t("Wil je overstappen van plan?")}</b>
            <br /> {$t("Neem contact op en we helpen je graag!")}
            <p>
              {$t("Stuur ons een email op")}
              <a
                style={{ marginLeft: 6 }}
                shape="circle"
                size="small"
                target="_blank"
                href={"mailto:" + email}
              >
                {email}
              </a>
            </p>
          </div>
        </Col>
      </Row>

      {clubData.plan !== "large" && (
        <Form.Item
          label={$t("Totaal aantal gebruiker slots")}
          name="seats"
          rules={[
            {
              required: true,
            },
          ]}
          extra={$t('Je betaalt per gebruiker een vast bedrag per maand')}
        >
          <Input type="number" style={{ maxWidth: 200 }} />
        </Form.Item>
      )}

      <Row gutter={12} style={{ marginBottom: 18 }}>
        <Col span={8} style={{ textAlign: "right" }}>
          {$t("Gebruikte gebruiker slots")}:{" "}
        </Col>

        <Col span={16}>{clubData.used_seats}</Col>
      </Row>

      <Row gutter={12} style={{ marginBottom: 18 }}>
        <Col span={8} style={{ textAlign: "right" }}>
          {$t("Algemene voorwaarden")}:{" "}
        </Col>

        <Col span={16}>
          {clubData.terms_name && (
            <>
              {$t("Getekend door")}: {clubData.terms_name}
            </>
          )}{" "}
          <a
            target="_blank"
            href={`https://www.gliding.app${
              config.isZweef ? "/nl" : ""
            }/terms.html`}
          >
            {$t("Zie text")}
          </a>
        </Col>
      </Row>
    </SettingCard>
  );
};
